module.exports = {
	Home: '/',
	Services: '/services/',
	Locations: '/locations/',
	About: '/about/',
	Contact: '/contact/',
};
